import axios from 'axios'
import { isObject, isEmpty } from 'lodash'
import { snakecase, camelcase } from '../_utils/camelcase'
import { state } from 'src/store.js'
import Toast from 'src/components/common/Toast/index'
import Cookies from 'js-cookie'

axios.defaults.timeout = 60000

axios.interceptors.request.use(function (config) {
  const { user } = state
  if (/\/api\/0.1/.test(config.url) && user.token && user.token.key) {
    config.headers.Authorization = `Token ${user.token.key}`
  }
  if (config.data instanceof FormData) { // 对图片上传做时间限制
    config.timeout = 2 * 60 * 1000
  }
  if (config.data && !(config.data instanceof FormData)) {
    try {
      config.data = snakecase(config.data, !isObject(config.data))
    } catch (err) {
      console.error(err)
    }
  }
  return config
})

axios.interceptors.response.use(
  /**
   * 此处需注意，后端已经统一处理返回值，请求成功均为200，4XX-5XX的错误放在error中catch
   * @param response
   * @returns {*}
   */
  function (response) {
    let data = response.data || {}
    data = camelcase(data)
    if (data.data) {
      data = data.data
    }
    if (data.errors) {
    }
    return data
  },
  function (err) {
    if (err.code === 'ECONNABORTED') { // 处理请求超时
      console.log(JSON.stringify(err))
      Toast({
        message: '请求超时，请刷新后检查网络链接'
      })
      return Promise.reject(new Error({ timeout: true }))
    }
    const { response } = err
    let errorCode = ''
    let status = ''
    if (!isEmpty(response) && isObject(response)) { // 存在错误内容
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Error',
        eventAction: JSON.stringify(response),
        eventLabel: 'Network-Error'
      })
      status = response.status
      if (response.data.errors) {
        errorCode = response.data.errors.code
      }

      errorHandle(status)
    }
    return Promise.reject(Error({
      errors: true,
      code: errorCode
    }))
  }
)

function errorHandle (status) {
  switch (status) {
    case 400:
      console.log('錯誤請求')
      Toast({
        message: '请求错误<br/>错误码：400'
      })
      break
    case 401:
      Toast({
        message: '授權失敗，請重新登錄'
      })
      Cookies.set('test_user', {}, { domain: '.ipastbook.com' })
      Cookies.set('m_user', {}, { domain: '.ipastbook.com' })
      Cookies.remove('m_user')
      Cookies.remove('test_user')
      window.location.href = '/'
      break
    case 403:
      console.log('該用戶無權訪問該資源')
      Toast({
        message: '无权访问该资源<br/>错误码：403'
      })
      break
    case 404:
      console.log('訪問資源不存在')
      Toast({
        message: '访问资源不存在<br/>错误码：404'
      })
      break
    case 500:
      console.log('服务器挂掉')
      Toast({
        message: '伺服器發生錯誤 - 500'
      })
      return
    case status > 503:
      console.log('七牛服务出问题')
      break
    default:
      Toast({
        message: '發生錯誤 - ' + status
      })
      console.log('請求錯誤')
  }
}

export default axios
